// Examples, not an exhaustive provider command enum. Accent patterns remain experimental.
const group = (id, label, cues, status = 'Documented') => ({ id, label, items: cues.map(cue => ({
  id: cue.toLowerCase().replace(/[^a-z0-9]+/g, '-'), label: cue.charAt(0).toUpperCase() + cue.slice(1),
  text: `[${cue}]`, cue, group: id, status,
})) });

export const VOICE_EXPRESSION_GROUPS = [
  group('reactions', 'Reactions', ['soft chuckle', 'chuckles', 'laughs', 'laughing', 'laughs harder', 'starts laughing', 'wheezing', 'sighs', 'exhales', 'clears throat', 'exhales sharply', 'inhales deeply', 'snorts', 'crying']),
  group('delivery', 'Delivery', ['whisper', 'whispers', 'whispering', 'shouting', 'measured', 'under his breath', 'quietly curious', 'singing', 'muttering', 'lower, thoughtful', 'Warm, conversational tone, faint amusement']),
  group('emotion', 'Emotion', ['happy', 'sad', 'excited', 'angry', 'annoyed', 'appalled', 'thoughtful', 'surprised', 'curious', 'sarcastic', 'mischievously']),
  group('pauses', 'Pauses', ['short pause', 'long pause']),
  group('accents', 'Accents', ['strong French accent', 'strong British accent', 'strong Australian accent', 'strong American accent', 'strong Indian accent', 'strong Irish accent', 'strong Scottish accent', 'strong Spanish accent', 'strong Italian accent', 'strong German accent'], 'Experimental'),
  group('custom', 'Custom', ['light chuckle', 'nervous', 'amused'], 'Custom'),
];
export const VOICE_EXPRESSIONS = VOICE_EXPRESSION_GROUPS.flatMap(g => g.items);
const escapeRE = text => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const cueNames = VOICE_EXPRESSIONS.map(item => escapeRE(item.cue));
const accentPattern = "(?:strong |soft |gentle |subtle |heavy )?[\\p{L}][\\p{L} '-]{0,60} accent";
export const voiceExpressionRE = (custom = []) => new RegExp(`\\[(?:${[...cueNames, accentPattern, ...custom.filter(validCustomCue).map(escapeRE)].join('|')})\\]`, 'giu');
export const VOICE_EXPRESSION_RE = voiceExpressionRE();

export function validCustomCue(value) {
  return typeof value === 'string' && value.length <= 80 && /^[\p{L}][\p{L}\p{M} ,'’.-]*$/u.test(value)
    && !/^(function|tool|contact|name|email|phone|address|company)$/i.test(value.trim());
}

export function detectAudioTag(text, caret) {
  const match = text.slice(0, caret).match(/(?:^|[\s("'“>])\[([^\[\]\n\r]{0,80})$/);
  if (!match || (match[1] && !validCustomCue(match[1]))) return null;
  return { mode: 'audio', query: match[1], start: caret - match[1].length - 1 };
}

export function audioTagItems(query, category, custom = []) {
  const q = query.trim().toLowerCase();
  const catalog = [...VOICE_EXPRESSIONS];
  custom.filter(validCustomCue).forEach((cue, index) => {
    if (!catalog.some(item => item.cue.toLowerCase() === cue.toLowerCase())) {
      catalog.push({ id: `saved-custom-${index}`, cue, text: `[${cue}]`, label: cue, group: 'custom', status: 'Custom' });
    }
  });
  const items = catalog.filter(item => (category === 'all' || category === item.group)
    && `${item.label} ${item.text}`.toLowerCase().includes(q));
  if (q && custom.length < 200 && validCustomCue(query.trim()) && !catalog.some(item => item.cue.toLowerCase() === q)) {
    items.push({ id: 'insert-custom', cue: query.trim(), text: `[${query.trim()}]`, label: `Insert [${query.trim()}]`,
      group: 'custom', status: / accent$/i.test(q) ? 'Experimental' : 'Custom', register: true });
  }
  return items.map(item => ({ ...item, kind: 'expression', insert: item.text, desc: item.text }));
}